<template>
    <div class="modal-text">
        <p>
            Votre profil est composé de toutes les informations utilisées lors de votre inscription. 
            Chaque information peut être modifiée sur la page 
            <router-link class="underline" :to="{ name: 'Account' }">
                <span>Mon profil</span>
            </router-link>. 
            Pour chaque modification, vous aurez besoin de <b>renseigner votre mot de passe actuel.</b>
            Cela nous permet de vérifier votre identité et d'éviter les vols de comptes.
        </p>

        <br />

        <p>
            Les informations de votre profil, en dehors de votre mot de passe, sont accessibles par les autres utilisateurs.
            Un utilisateur ne peut cependant <b>pas retrouver votre adresse mail</b> avec votre pseudonyme uniquement.
        </p>

        <br />

        <p>Votre profil est composé de :</p>
        <ul class="list-disc list-inside">
            <li class="my-1">
                <b>Un identifiant</b>, de type pseudonyme, pour permettre aux autres
                utilisateurs de vous identifier facilement. Vous n'êtes pas obligé de
                mentionner votre nom, prénom ou autre toute autre information
                personnelle.
            </li>
            <li class="my-1">
                <b>Une adresse mail</b> qui nous permet de vous contacter dans le cas
                d'un mot de passe égaré. Celle-ci doit être <b>unique !</b>, 
                vous ne pouvez pas avoir plusieurs comptes avec une seule adresse mail.
            </li>
            <li class="my-1">
                <b>Un mot de passe</b> qui vous permettra de vous identifier par la
                suite. <b>Celui-ci doit être de 5 caractères de longueur minimum !</b>
            </li>
            <li class="my-1">
                <b>Un avatar coloré</b> qui va permettre aux autres utilisateurs de vous identifier plus facilement.
                Vous pouvez modifier sa couleur parmi une palette définie.
            </li>
        </ul>

        <br />

        <p>
            Vous êtes libre de supprimer votre compte, nous ne gardons aucune information concernant celui-ci après suppression. 
            Supprimer votre compte <b>est définitif</b> : cela va également supprimer les projets que vous avez créés et vous retirer des projets auxquels vous avez participé.
        </p>

        <hr class="my-5" />

        <h3>Liens utiles</h3>

        <ul class="list-disc list-inside">
            <li class="my-1">
                <router-link class="link" :to="{ name: 'Authentication' }">
                <span>Formulaire de connexion et d'inscription</span>
                </router-link>
            </li>
            <li class="my-1">
                <router-link class="link" :to="{ name: 'Account' }">
                <span>Consulter les informations de mon compte</span>
                </router-link>
            </li>
            <li class="my-1">
                <router-link class="link" :to="{ name: 'CGU' }">
                <span>Conditions générales d'utilisation</span>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
export default { 
    name: "ConnectionDialogContent"
}
</script>
